import React, { useRef, useState, useEffect } from 'react'; //import React Component
import { useParams } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore, storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, query, collection, where, updateDoc, getDocs } from 'firebase/firestore';

export function Revise() {
    // Get current check card
    const params = useParams();
    const rawNameString = params.revise;
    let nameString = (rawNameString).replace('%20', " ");
    let readcardName = nameString.split(":&:")[0];
    // let readcardauthor = nameString.split(":&:")[1];

    //Collect all the data from input
    const [prointro, setprointro] = useState('');
    const [proprice, setproprice] = useState('');
    const [pic, setpic] = useState('');
    const [oripic, setoripic] = useState('');
    const [brand, setbrand] = useState("")
    const [otherCate, setotherCate] = useState("")
    const [tag, settag] = useState("")
    const [stock, setstock] = useState('');
    const [proID, setproID] = useState('');
    const [proname, setproname] = useState('');
    const imageRef = useRef("")
    const other = useRef("")
    const metadata = {
        contentType: "image/jpeg"
    }; //Image type

    const [extractData, setextractData] = useState([])//already exsited
    useEffect(() => {
        const image = document.querySelector(".uploadImg");
        if (prointro.length === 0 && proprice.length === 0 &&
            brand.length === 0 && otherCate.length === 0 && tag.length === 0 && image.value.length === 0 && stock.length === 0) {
            getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proname", "==", readcardName)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setextractData(data)
                })
            if (extractData.length > 0) {
                setprointro(extractData[0].Product_Information.prointro)
                setproprice(extractData[0].Product_Information.proprice)
                setpic(extractData[0].Product_Information.pic)
                setoripic(extractData[0].Product_Information.pic)
                setbrand(extractData[0].Product_Information.brand)
                setotherCate(extractData[0].Product_Information.tag)
                settag(extractData[0].Product_Information.tag)
                setstock(extractData[0].LeftNum)
                setproID(extractData[0].Product_Information.proID)
                setproname(extractData[0].Product_Information.proname)
            }
        }
    })

    //Set value
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        const image = imageRef.current;
        if (id === "propic") {
            if (image.value.length > 0) {
                document.getElementsByTagName("label")[0].style.color = "black"
            }
            var divsToRemove = document.querySelectorAll(".resize");
            if (divsToRemove.length > 0) {
                for (var i = 0; i < divsToRemove.length; i++) {
                    divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                }
            }
            if (image.value.length !== 0) {
                setpic(image.files[0]);
                let imgName = image.files[0].name.split(".")[0];
                const tempo = ref(storage, "Tempo_forAddWelcome/" + imgName);
                const uploadTask = uploadBytesResumable(tempo, image.files[0], metadata)
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        const img_tips = document.createElement("div");
                        var text = document.createTextNode('Upload is ' + progress.toFixed(2) + '% done');
                        img_tips.appendChild(text);
                        img_tips.classList.add("img_tips");
                        image.after(img_tips);
                        setTimeout(() => { img_tips.classList.add("disappear") }, 3000);
                    },
                    (error) => {
                        console.log(error);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            const img = document.createElement("img");
                            img.classList.add("resize");
                            img.src = downloadURL;
                            img.id = pic.name;
                            image.after(img);
                        });
                    }
                );
            }
        }
        if (id === "proname") {
            setproname(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[1].style.color = "black"
            }
        }
        if (id === "otherCate") {
            setotherCate(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[3].style.color = "black"
                settag(value)
            }
        }
        if (id === "brand") {
            setbrand(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[4].style.color = "black"
            }
        }
        if (id === "prointro") {
            setprointro(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[5].style.color = "black"
            }
        }
        if (id === "proprice") {
            setproprice(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[6].style.color = "black"
            }
        }
    }

    const productGenres = [
        "速食米饭",
        "速食火锅",
        "肉食",
        "速食汤面",
        "休闲零食",
        "饮料",
        "手工甜点",
    ];
    useEffect(() => {
        document.querySelectorAll("select option").forEach(option => {
            if (option.value === tag) {
                option.style.backgroundColor = "rgb(103, 167, 223)"
                option.style.color = "white"
            } else if (!productGenres.includes(tag) && !productGenres.includes(option.value)) {
                option.style.backgroundColor = "rgb(103, 167, 223)"
                option.style.color = "white"
                other.current.style.display = "block";
            } else {
                option.style.backgroundColor = "aliceblue"
                option.style.color = "black"
            }
        });
    })

    const filterBoard = (e) => {
        const { value } = e.target;
        settag(value)
        document.getElementsByTagName("label")[2].style.color = "black"
        if (value === "") {
            other.current.style.display = "block";
        } else {
            other.current.style.display = "none";
        }
    }

    //Upload all the data in firebase
    //Also show error when recieved error input
    const add_post = async () => {
        const 这个是二级保证 = localStorage.getItem("这个是二级保证");
        const userName = localStorage.getItem("currentLoginUser");
        const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
        const userData = userExist.docs.map(doc => doc.data());
        const image = document.querySelector(".uploadImg");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.style.display = "none" }, 4500);
        let button = document.querySelector(".submit");

        if (userData[0]) {
            if (userData[0].officer === true && 这个是二级保证 === "true") {
                if (proname.trim().length > 0 && prointro.trim().length > 0 && proprice.trim().length > 0 && tag.trim().length > 0 && pic.length !== 0 &&
                    brand.trim().length > 0) {
                    if (readcardName.match("%20") || readcardName.match(":&:")) {
                        text = document.createTextNode("For security, we are not allowed string ':&:' and '%20'.");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    } else {
                        const storageRef = ref(storage, "Product Image/" + readcardName + userName);
                        if (document.querySelector(".resize")) {
                            document.querySelector(".resize").style.display = "none";
                            var divsToRemove = document.querySelectorAll(".resize");
                            if (divsToRemove.length > 0) {
                                for (var i = 0; i < divsToRemove.length; i++) {
                                    divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                                }
                            }
                        }

                        if (image.value.length > 0) {
                            uploadBytesResumable(storageRef, pic, metadata).then(() => { //Store img
                                getDownloadURL(storageRef).then(async (downloadURL) => {
                                    const docData = {
                                        "Product_Information.prointro": prointro,
                                        "Product_Information.proprice": proprice,
                                        "Product_Information.pic": downloadURL,
                                        "Product_Information.proname": proname,
                                        "Product_Information.tag": tag,
                                        "Product_Information.brand": brand,
                                        "Product_Information.lastReviseDate": new Date()
                                    }
                                    console.log(proID)
                                    updateDoc(doc(cloudStore, "productData", proID), docData).then(() => {
                                        var newDiv2 = document.createElement("div");
                                        var text = document.createTextNode(" Finished Processing");
                                        newDiv2.classList.add("tips");
                                        newDiv2.appendChild(text);
                                        newDiv2.style.color = "red"
                                        button.after(newDiv2);
                                        setTimeout(() => { window.location.reload() }, 500);
                                    })
                                })
                            });
                        } else {
                            const docData = {
                                "Product_Information.prointro": prointro,
                                "Product_Information.proprice": proprice,
                                "Product_Information.pic": pic,
                                "Product_Information.proname": proname,
                                "Product_Information.tag": tag,
                                "Product_Information.brand": brand,
                                "Product_Information.lastReviseDate": new Date()
                            }
                            updateDoc(doc(cloudStore, "productData", proID), docData).then(() => {
                                var newDiv2 = document.createElement("div");
                                var text = document.createTextNode(" Finished Processing");
                                newDiv2.classList.add("tips");
                                newDiv2.appendChild(text);
                                newDiv2.style.color = "red"
                                button.after(newDiv2);
                                setTimeout(() => { window.location.href = "/profile" }, 500);
                            })
                        }

                        text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    }
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (pic.length === 0) {
                        document.getElementsByTagName("label")[0].style.color = "red"
                    }
                    if (proname.length === 0) {
                        document.getElementsByTagName("label")[1].style.color = "red"
                    }
                    if (tag.length === 0) {
                        document.getElementsByTagName("label")[2].style.color = "red"
                        document.getElementsByTagName("label")[3].style.color = "red"
                    }
                    if (brand.length === 0) {
                        document.getElementsByTagName("label")[4].style.color = "red"
                    }
                    if (prointro.length === 0) {
                        document.getElementsByTagName("label")[5].style.color = "red"
                    }
                    if (proprice.length === 0) {
                        document.getElementsByTagName("label")[6].style.color = "red"
                    }
                }
            } else {
                text = document.createTextNode("You are not officer.");
                newDiv.appendChild(text);
                button.after(newDiv);
            }
        } else {
            text = document.createTextNode("You have not signin.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    return (
        <div id='addWelcome'>
            <Navigation />
            <main>
                <div className="add">
                    <h1 className="title">Revise: {readcardName}</h1>
                    <form>
                        <label htmlFor="propic">Product Picture: </label>
                        <input
                            className="uploadImg"
                            type="file"
                            id="propic"
                            accept="image/jpeg, image/png, image/jpg"
                            style={{ maxWidth: "360px", border: "none" }}
                            ref={imageRef}
                            onChange={(e) => { handleInputChange(e) }}
                        />
                        <div>
                            <label htmlFor="propic">Original Picture: </label>
                            <img
                                src={oripic}
                                alt={pic}
                                style={{
                                    width: "250px",
                                    height: "250px",
                                    borderRadius: "40px",
                                    objectFit: "contain"
                                }} />
                        </div>
                        <br />
                        <label htmlFor="proname">Product Name: </label>
                        <input
                            type="text"
                            id="proname"
                            placeholder="Write Product Name"
                            onChange={(e) => { handleInputChange(e) }}
                            value={proname}
                        />
                        <br />
                        <label htmlFor="procate">Product Category: </label>
                        <select multiple>
                            <option value="速食米饭" onClick={(e) => filterBoard(e)}>速食米饭</option>
                            <option value="速食火锅" onClick={(e) => filterBoard(e)}>速食火锅</option>
                            <option value="速食汤面" onClick={(e) => filterBoard(e)}>速食汤面</option>
                            <option value="肉食" onClick={(e) => filterBoard(e)}>肉食</option>
                            <option value="休闲零食" onClick={(e) => filterBoard(e)}>休闲零食</option>
                            <option value="饮料" onClick={(e) => filterBoard(e)}>饮料</option>
                            <option value="手工甜点" onClick={(e) => filterBoard(e)}>手工甜点</option>
                            <option value="" onClick={(e) => filterBoard(e)}>Other</option>
                        </select>
                        <div
                            style={{ display: "none", margin: "auto", width: "60%", textAlign: "center" }}
                            ref={other}>
                            <label htmlFor="otherCate">Enter your option:</label>
                            <input type="text" id="otherCate" onChange={(e) => handleInputChange(e)} value={otherCate} />
                        </div>
                        <br />
                        <label htmlFor="brand">Product Brand: </label>
                        <input
                            type="text"
                            id="brand"
                            placeholder="Write Product Brand"
                            onChange={(e) => { handleInputChange(e) }}
                            value={brand}
                        />
                        <br />
                        <label htmlFor="prointro">Product Introduction: </label>
                        <textarea
                            className='needToBeBig'
                            type="text"
                            id="prointro"
                            placeholder="Write Product Introduction"
                            onChange={(e) => { handleInputChange(e) }}
                            value={prointro}
                        ></textarea>
                        <br />
                        <label htmlFor="proprice">Product Price: </label>
                        <input
                            type="number"
                            id="proprice"
                            placeholder="Write Product Price"
                            onChange={(e) => { handleInputChange(e) }}
                            value={proprice}
                        />
                        <div>库存剩余: {stock}件. 此数据无法直接修改。</div>
                        <div className="button submit" onClick={add_post}>Submit</div>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
}